<div class="wrapper">
  <div class="cuerpo">
    <h1 class="tp-navandu line-navandu">PLANTILLAS DISPONIBLES</h1>

    <div class="input-field col s12 buscador">
      <input id="filter" type="text" (keyup)="applyFilter($event)" [(ngModel)]="textToSearch">
      <label for="filter" data-error="Ingrese un dato valido" data-success="">
        <button mat-icon-button type="button" (click)="search()">
          <i class="material-icons">search</i>
        </button>
      </label>
    </div>

    @if (loading) {
    <app-spinner></app-spinner>
    } @else {
    @if (showOwnDocument) {
    <div class="ownDocument">
      <div class="labelOwn">
        <span>Enviar a firmar documento propio</span>
      </div>
      <div class="iconOwn">
        <button mat-icon-button type="button" class="refrescar action-icon-btn" (click)="uploadDocument(uuid)"
          matTooltip="Enviar documento" matTooltipPosition="above">
          <mat-icon>publish</mat-icon>
        </button>
      </div>
    </div>
    }

    <table mat-table [dataSource]="dataSource" class="tabla">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Nombre </th>
        <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> Descripción </th>
        <td mat-cell *matCellDef="let element"> {{ element.description }} </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> Acción </th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button type="button" class="action-icon-btn" (click)="view(element.uuid)"
            matTooltip="Detalles" matTooltipPosition="above">
            <mat-icon>remove_red_eye</mat-icon>
          </button>

          <button mat-icon-button type="button" class="action-icon-btn" (click)="sign(element.uuid)"
            matTooltip="Generar" matTooltipPosition="above">
            <mat-icon>send</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    }

    <mat-paginator [pageSizeOptions]="[20, 50, 100]" showFirstLastButtons></mat-paginator>
  </div>
</div>